<template>
  <main id="main">
    <div class="header_page justify-content-between">
        <img src="@/assets/imgs/share.svg" class="icon-size-3 cursor-pointer" alt="" @click="shareContent('post', post.caption)">

        <div class="d-flex align-items-center">
            <p id="title_header_page" class="">{{ t('post_details') }}</p>
            <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
        </div>
    </div>

    <div v-if="loading" class="text-center mt-5">
        <p>{{ t('loading') }}</p>
    </div>

    <div v-else-if="!post.id" class="text-center mt-5 text_color_gray">
        {{ t('post_info_not_found') }}
    </div>

    <div v-else class="p-3">
        <div class="bg_white rounded-5 p-3 shadow">
            <img style="max-height: 30rem; object-fit: contain;" :src="post.pic" class="rounded-5 w-100 shadow mb-5 bg-dark" alt="" @error="$event.target.src = require('@/assets/imgs/NoPath - Copy (5).png')">

            <div class="bg_box_light_theme shadow-sm p-3 d-flex justify-content-between align-items-center rounded-4 mb-4">
                <div class="d-flex align-items-center gap-3">
                    <img src="@/assets/imgs/clock.svg" class="icon-size-2" alt="">
                    <p class="font_small">{{ post.created_at_local }}</p>
                </div>

                <div class="d-flex align-items-center gap-3">
                    <div class="d-flex align-items-center gap-1 cursor-pointer" @click="goToLikes">
                        <img src="@/assets/imgs/heart.svg" class="icon-size-2" alt="">
                        <p class="font_normal">{{ post.likes }}</p>
                    </div>
                </div>
            </div>

            <p class="font_normal mb-3" style="white-space: pre-wrap; text-align: justify; line-height: 2rem;">{{ post.caption }}</p>
        </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'TeacherPostDetail',
  data() {
    return {
        post: {},
        loading: false,
        postId: null
    }
  },
  mounted() {
    this.postId = this.$route.query.id;
    if (this.postId) {
        this.fetchPost();
    }
  },
  methods: {
    async fetchPost() {
        this.loading = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId,
                post_id: this.postId
            });

            const response = await apiClient.post('/teacher/show_details_post', formData);

            if (response.data.status === 'ok' && response.data.data) {
                this.post = response.data.data;
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.loading = false;
        }
    },
    goToLikes() {
        this.$router.push({ name: 'TeacherLikesList', query: { postId: this.postId } });
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>